<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="28"
    height="29"
    viewBox="0 0 28 29"
    fill="none"
  >
    <path
      d="M18.375 25C18.375 25.2321 18.2828 25.4546 18.1187 25.6187C17.9546 25.7828 17.7321 25.875 17.5 25.875H10.5C10.2679 25.875 10.0454 25.7828 9.8813 25.6187C9.7172 25.4546 9.62501 25.2321 9.62501 25C9.62501 24.7679 9.7172 24.5454 9.8813 24.3813C10.0454 24.2172 10.2679 24.125 10.5 24.125H17.5C17.7321 24.125 17.9546 24.2172 18.1187 24.3813C18.2828 24.5454 18.375 24.7679 18.375 25ZM24.2605 19.7434C23.6524 18.6978 22.75 15.7392 22.75 11.875C22.75 9.55436 21.8281 7.32876 20.1872 5.68782C18.5463 4.04687 16.3207 3.125 14 3.125C11.6794 3.125 9.45377 4.04687 7.81283 5.68782C6.17189 7.32876 5.25001 9.55436 5.25001 11.875C5.25001 15.7403 4.34658 18.6978 3.73955 19.7434C3.58453 20.0093 3.50235 20.3113 3.50129 20.619C3.50024 20.9267 3.58034 21.2293 3.73353 21.4962C3.88672 21.7631 4.10757 21.9848 4.37382 22.1391C4.64006 22.2934 4.94229 22.3748 5.25001 22.375H22.75C23.0576 22.3746 23.3597 22.2931 23.6258 22.1387C23.8919 21.9843 24.1126 21.7625 24.2657 21.4957C24.4187 21.2288 24.4987 20.9263 24.4976 20.6187C24.4965 20.3111 24.4144 20.0092 24.2594 19.7434H24.2605Z"
      fill="currentColor"
    />
  </svg>
</template>

<script>
export default {
  name: "bellIcon",
};
</script>
